// extracted by mini-css-extract-plugin
export var compact = "List-module--compact--8b68c";
export var item = "List-module--item--83ed9";
export var list = "List-module--list--72052";